import * as React from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import { useMyIdentities, ViewMe } from "@njoy/controller";
import { TemplateSub } from "../../../components/layouts/TemplateSub";
import Loader from "../../../components/loader/Loader";
import { AddButton } from "../../shared/AddButton";
import { Tooltip } from "antd";
import IdCard from "../../../modules/shared/NjoyIdCard";
import CardStack from "../../../components/cards/CardStack";
import { QrCode } from '../../../components/shared/QrCode';
import IdCardSkeletonStack from "../../../components/cards/IdCardSkeletonStack";

import * as ROUTES from "../../../constants/routes";

export const ManageIdCards: React.FC = () => {
  const { myIdentities, loading } = useMyIdentities({ limit: 5, offset: 0 });
  const navigate = useNavigate();

  return (
    <TemplateSub
      page={"Manage ID Cards"}
      icon={
        !!myIdentities && myIdentities.length > 2 ? (
          <Tooltip title="You can only add up to 3 IDs">
            <span>
              <AddButton
                disabled
              />
            </span>
          </Tooltip>
        ) : (
          <AddButton
            onClick={() => {
              if (!myIdentities || myIdentities.length < 3) {
                navigate(ROUTES.CONNECT_ID);
              }
            }}
          />
        )
      }
    >
      <ViewMe>
        {(data) => {
          if (!data.match) {
            return <Loader center text="Fetching user detail" noLeftMargin />;
          }

          if (loading) {
            return <IdCardSkeletonStack />;
          }

          if (!myIdentities || myIdentities.length === 0) {
            return (
              <div className="px-4">
                <div className="p-3 flex flex-col items-center gap-2 mt-7 bg-[#1E1E1E] rounded-lg">
                  <p className="text-[#B2B2B2] text-[14px] ">No ID to manage</p>
                </div>
              </div>
            );
          }

          return (
            <div className="px-[2.5rem] min-[450px]:px-[3rem] mx-auto w-full">
              <div className="mx-auto w-full min-w-0 flex flex-col">
                <CardStack
                  height={500}
                  width={"100%"}
                  selectedStackGap={38}
                  headerHeight={20}
                  topHeight={20}
                  hoverOffset={0}
                  initialCard={-1}>
                  {myIdentities.map((m) => (
                    <IdCard
                      key={m.id || `${m.community?.id || "community"}-${m.idNumber}-${m.validity}`}
                      communityLogo={m.community?.logoUrl || ''}
                      qrCode={
                        <QrCode value={`${m.community?.alias}: ${m.idNumber.toString()}`} size={42} />
                      }
                      communityName={m.community?.name || ''}
                      name={m.name}
                      validity={moment(m.validity).format("DD-MM-YYYY")}
                      idNumber={m.idNumber}
                      dob={m.dob || ''}
                      gender={
                        m.gender === "m" ? "Male" :
                          m.gender === "f" ? "Female" :
                            m.gender
                      }
                      cardColor={m.community?.colorCode || null}
                    />
                  ))}
                </CardStack>
              </div>
            </div>
          );
        }}
      </ViewMe>
    </TemplateSub>
  );
};
